import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import posthog from 'posthog-js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  constructor(public translate: TranslateService, private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => posthog.capture('$pageview'));
    translate.addLangs(['en', 'de', 'fr', 'pl']);

    const language = localStorage.getItem('language');
    translate.setDefaultLang('en');

    if (language !== undefined && language !== '' && language !== null) {
      translate.use(language);
    } else {
      const browserLang = translate.getBrowserLang();
      const lang = browserLang.match(/en|de|fr|pl/) ? browserLang : 'en';
      localStorage.setItem('language', lang);
      translate.use(lang);
    }
  }
}
